import { AnyAction } from 'redux'

type EventsMapper = (action: AnyAction) => any[]
type Target = (events: any[]) => void
type FullStackTrackable = any

export const optimizelyTarget = (): Target =>
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (_events: FullStackTrackable[]) => {
    // No-op - Optimizely tracking disabled
  }

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const eventsMap: EventsMapper = (_action: AnyAction) => {
  return []
}

export const opMiddleware =
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (_store: any) =>
  (next: any) =>
  (action: any) => {
    return next(action)
  }